import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      value: _ctx.computedValor,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
      onChange: _ctx.defineValorSelecionado,
      class: "ss-tamanho-completo",
      disabled: _ctx.props.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_select_option, { value: "06" }, {
          default: _withCtx(() => [
            _createTextVNode("Automóvel")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "23" }, {
          default: _withCtx(() => [
            _createTextVNode("Caminhonete")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "13" }, {
          default: _withCtx(() => [
            _createTextVNode("Camioneta")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "14" }, {
          default: _withCtx(() => [
            _createTextVNode("Caminhão")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "17" }, {
          default: _withCtx(() => [
            _createTextVNode("Caminhão Trator")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "04" }, {
          default: _withCtx(() => [
            _createTextVNode("Motociclo")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "03" }, {
          default: _withCtx(() => [
            _createTextVNode("Motoneta")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "02" }, {
          default: _withCtx(() => [
            _createTextVNode("Ciclomoto")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "05" }, {
          default: _withCtx(() => [
            _createTextVNode("Triciclo")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "21" }, {
          default: _withCtx(() => [
            _createTextVNode("Quadriciclo")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "07" }, {
          default: _withCtx(() => [
            _createTextVNode("Micro-ônibus")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "08" }, {
          default: _withCtx(() => [
            _createTextVNode("Ônibus")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "22" }, {
          default: _withCtx(() => [
            _createTextVNode("Especial/Ônibus")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "10" }, {
          default: _withCtx(() => [
            _createTextVNode("Reboque")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "11" }, {
          default: _withCtx(() => [
            _createTextVNode("Semirreboque")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "25" }, {
          default: _withCtx(() => [
            _createTextVNode("Utilitário")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "26" }, {
          default: _withCtx(() => [
            _createTextVNode("Motor-casa")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "18" }, {
          default: _withCtx(() => [
            _createTextVNode("Trator Rodas")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "19" }, {
          default: _withCtx(() => [
            _createTextVNode("Trator Esteiras")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "20" }, {
          default: _withCtx(() => [
            _createTextVNode("Trator Misto")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: "24" }, {
          default: _withCtx(() => [
            _createTextVNode("Carga/CAM")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onChange", "disabled"])
  ]))
}